import React from 'react';
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { colors } from '../../brand-colors';

/**
 * Upsells Chart - Donut showing upsell item breakdown
 */
function UpsellsChart({ data }) {
  // Convert object to array for chart
  const chartData = data && typeof data === 'object'
    ? Object.entries(data).map(([name, value], index) => ({
        name,
        value,
        color: COLORS[index % COLORS.length]
      }))
    : [];

  if (chartData.length === 0) {
    return (
      <div style={styles.placeholder}>
        <p>No upsell data available</p>
        <small>Upsells will appear when tracked in GHL</small>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={2}
          dataKey="value"
          label={({ name, percent }) =>
            percent > 0.05 ? `${(percent * 100).toFixed(0)}%` : ''
          }
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            color: colors.greyDarkest
          }}
          formatter={(value) => [`$${value.toLocaleString()}`, '']}
        />
        <Legend
          wrapperStyle={{ color: colors.grey, fontSize: 11 }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}

// Extended color palette for multiple upsells
const COLORS = [
  colors.tealDark,
  colors.teal,
  colors.tealMid,
  '#2DD4BF',  // Additional teal shades
  '#14B8A6',
  '#0D9488',
  '#0F766E'
];

const styles = {
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center'
  }
};

export default UpsellsChart;
